import { forwardRef } from 'react';

const MESES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

const TOP3 = {
  1: { medal: '🥇', posLabel: '1° LUGAR', posColor: '#C9A227', phrase: 'Você foi a pessoa mais presente do clube em {mes}! Parabéns!' },
  2: { medal: '🥈', posLabel: '2° LUGAR', posColor: '#9E9E9E', phrase: 'Vice-líder de {mes}. Quase no topo!' },
  3: { medal: '🥉', posLabel: '3° LUGAR', posColor: '#CD7F32', phrase: 'Top 3 de {mes}. Sua presença é essencial!' },
};

const RankingResultadoCard = forwardRef(function RankingResultadoCard({ resultado }, ref) {
  const month = new Date(resultado.month + 'T00:00:00Z');
  const mesNome = MESES[month.getUTCMonth()];
  const isTop3 = resultado.rank >= 1 && resultado.rank <= 3;
  const top3 = TOP3[resultado.rank];
  const phrase = isTop3
    ? top3.phrase.replace('{mes}', mesNome)
    : `Você foi essencial para a comunidade em ${mesNome}.`;

  const s = {
    card: {
      width: 360, height: 640,
      background: 'linear-gradient(160deg, #2f2b5f 0%, #1a1838 60%, #2a1f4a 100%)',
      display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
      padding: '32px 32px 28px',
      position: 'relative', overflow: 'hidden',
      fontFamily: "'DM Sans', sans-serif",
      boxSizing: 'border-box',
    },
    blob1: { position: 'absolute', borderRadius: '50%', pointerEvents: 'none', width: 280, height: 280, background: 'radial-gradient(circle, rgba(123,94,167,0.35) 0%, transparent 70%)', top: -60, right: -80 },
    blob2: { position: 'absolute', borderRadius: '50%', pointerEvents: 'none', width: 220, height: 220, background: 'radial-gradient(circle, rgba(167,139,250,0.2) 0%, transparent 70%)', bottom: 40, left: -60 },
    header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 },
    headerLeft: { display: 'flex', alignItems: 'center', gap: 7 },
    logoText: { fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 16, fontWeight: 600, color: 'rgba(255,255,255,0.88)' },
    ig: { display: 'flex', alignItems: 'center', gap: 4 },
    igHandle: { fontSize: 11, color: 'rgba(255,255,255,0.35)' },
    body: { display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', zIndex: 1, flex: 1, justifyContent: 'center', padding: '8px 0' },
    // top 3
    medal: { fontSize: 52, lineHeight: '60px', display: 'block', textAlign: 'center', marginBottom: 4 },
    avatarTop3: { fontSize: 26, background: 'rgba(255,255,255,0.08)', borderRadius: '50%', width: 52, height: 52, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 10px', border: '2px solid rgba(201,162,39,0.35)' },
    posicao: { fontSize: 10, fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', textAlign: 'center', display: 'block', marginBottom: 3 },
    nome: { fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 24, fontWeight: 600, color: '#fff', textAlign: 'center', display: 'block', marginBottom: 18 },
    // fora top 3
    emojiGrande: { fontSize: 64, lineHeight: '72px', display: 'block', textAlign: 'center', marginBottom: 8 },
    mesLabel: { fontSize: 9, fontWeight: 700, letterSpacing: '0.14em', color: 'rgba(167,139,250,0.8)', textTransform: 'uppercase', textAlign: 'center', display: 'block', marginBottom: 2 },
    mesTitulo: { fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 28, fontWeight: 600, color: '#fff', textAlign: 'center', display: 'block', marginBottom: 16 },
    divider: { width: 36, height: 1, background: 'rgba(255,255,255,0.2)', margin: '0 auto 16px' },
    // pontos
    ptsBig: { fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 72, fontWeight: 600, color: '#fff', lineHeight: '72px', display: 'block', textAlign: 'center' },
    ptsLabel: { fontSize: 10, color: 'rgba(255,255,255,0.5)', letterSpacing: '0.1em', textTransform: 'uppercase', textAlign: 'center', display: 'block', marginBottom: 20, marginTop: 2 },
    // stats
    statsRow: { display: 'flex', justifyContent: 'center', alignItems: 'flex-start', width: '100%', marginBottom: 22 },
    statCol: { display: 'flex', flexDirection: 'column', alignItems: 'center', width: 80 },
    statNum: { fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 36, fontWeight: 600, color: '#c4b5fd', lineHeight: '36px', display: 'block', textAlign: 'center' },
    statLabel: { fontSize: 9, color: 'rgba(255,255,255,0.45)', textTransform: 'uppercase', letterSpacing: '0.06em', textAlign: 'center', display: 'block', marginTop: 4 },
    statDivider: { width: 1, height: 44, background: 'rgba(255,255,255,0.15)', alignSelf: 'center', marginTop: 0 },
    // frase
    phrase: { fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: 'rgba(255,255,255,0.65)', textAlign: 'center', lineHeight: '20px', display: 'block' },
    footer: { position: 'relative', zIndex: 1, textAlign: 'center' },
    footerUrl: { fontSize: 11, color: 'rgba(255,255,255,0.3)', letterSpacing: '0.06em' },
  };

  return (
    <div ref={ref} style={s.card}>
      <div style={s.blob1} />
      <div style={s.blob2} />

      <div style={s.header}>
        <div style={s.headerLeft}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#a78bfa">
            <path d="M12 2 L13.8 10.2 L22 12 L13.8 13.8 L12 22 L10.2 13.8 L2 12 L10.2 10.2 Z"/>
          </svg>
          <span style={s.logoText}>Clube do Eu</span>
        </div>
        <div style={s.ig}>
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
            <circle cx="12" cy="12" r="4"/>
            <circle cx="17.5" cy="6.5" r="0.5" fill="rgba(255,255,255,0.3)" stroke="none"/>
          </svg>
          <span style={s.igHandle}>@oclubedoeu</span>
        </div>
      </div>

      <div style={s.body}>
        {isTop3 ? (
          <>
            <span style={s.medal}>{top3.medal}</span>
            <div style={s.avatarTop3}>{resultado.avatar_emoji || '😶'}</div>
            <span style={{ ...s.posicao, color: top3.posColor }}>{top3.posLabel}</span>
            <span style={s.nome}>{resultado.display_name}</span>
          </>
        ) : (
          <>
            <span style={s.emojiGrande}>{resultado.avatar_emoji || '😶'}</span>
            <span style={s.mesLabel}>Seu mês</span>
            <span style={s.mesTitulo}>{mesNome}</span>
            <div style={s.divider} />
          </>
        )}

        <span style={s.ptsBig}>{resultado.points}</span>
        <span style={s.ptsLabel}>{isTop3 ? `pontos em ${mesNome}` : 'pontos'}</span>

        <div style={s.statsRow}>
          <div style={s.statCol}>
            <span style={s.statNum}>{resultado.checkins_count}</span>
            <span style={s.statLabel}>check-ins</span>
          </div>
          <div style={s.statDivider} />
          <div style={s.statCol}>
            <span style={s.statNum}>{resultado.reflexoes_count}</span>
            <span style={s.statLabel}>reflexões</span>
          </div>
        </div>

        <span style={s.phrase}>{phrase}</span>
      </div>

      <div style={s.footer}>
        <p style={s.footerUrl}>oclubedoeu.com.br</p>
      </div>
    </div>
  );
});

export default RankingResultadoCard;
